var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"green clear-button",attrs:{"tile":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.setCurrentInput(null)}}},[_c('font-awesome-icon',{staticClass:"side-icon",attrs:{"icon":"undo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }